import { Link } from 'react-router'
import { BrandMark } from '#app/components/brand/logo.tsx'

const footerCols = [
	{
		head: 'Product',
		links: [
			{ label: 'Free competitor checker', href: '/free-backlink-checker' },
			{ label: 'Who links to my website?', href: '/who-links-to-my-website' },
			{ label: 'Backlink gap analysis', href: '/guides/backlink-gap-analysis' },
			{ label: 'How it works', href: '/#how-it-works' },
			{ label: 'Pricing', href: '/pricing' },
		],
	},
	{
		head: 'Learn',
		links: [
			{ label: 'Guides', href: '/guides' },
			{ label: 'Best tools', href: '/best-tools' },
			{ label: 'The course', href: '/course' },
			{ label: 'What is a backlink?', href: '/guides/what-is-a-backlink' },
			{ label: 'How to get backlinks', href: '/guides/how-to-get-backlinks' },
			{ label: 'Glossary', href: '/guides/backlink-glossary' },
		],
	},
	{
		head: 'Company',
		links: [
			{ label: 'About', href: '/about' },
			{ label: 'Affiliate disclosure', href: '/about#affiliate-disclosure' },
			{ label: 'Terms of Service', href: '/tos' },
			{ label: 'Privacy', href: '/privacy' },
			{ label: 'Log in', href: '/login' },
		],
	},
]

export function Footer() {
	return (
		<footer className="border-hairline mt-[84px] border-t">
			<div className="mx-auto grid max-w-[1200px] gap-10 px-8 py-[60px] pb-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
				<div>
					<Link to="/" className="text-ink mb-3.5 flex items-center gap-2.5">
						<BrandMark size={26} />
						<span className="font-display text-base font-bold">
							competitorbacklinks
							<span className="font-semibold text-[#9A968C]">.com</span>
						</span>
					</Link>
					<p className="mb-5 max-w-[280px] text-sm leading-relaxed text-[#8A867D]">
						Link intelligence, demystified. The friendly way to understand
						competitor backlinks: a free tool, jargon-free guides, and honest
						recommendations.
					</p>
					<Link
						to="/free-backlink-checker"
						className="bg-brand inline-flex h-10 items-center rounded-lg px-5 text-sm font-semibold text-white no-underline transition-colors hover:opacity-90"
					>
						Run a free competitor backlink check →
					</Link>
				</div>

				{footerCols.map((col) => (
					<div key={col.head}>
						<div className="mb-4 text-[12.5px] font-semibold tracking-[0.05em] text-[#8A867D] uppercase">
							{col.head}
						</div>
						<div className="flex flex-col gap-[11px]">
							{col.links.map((l) => (
								<Link
									key={l.label}
									to={l.href}
									className="hover:text-ink text-[14.5px] text-[#4A4952]"
								>
									{l.label}
								</Link>
							))}
						</div>
					</div>
				))}
			</div>

			<div className="border-hairline mx-auto flex max-w-[1200px] flex-wrap items-center justify-between gap-4 border-t px-8 py-6 text-[13px] text-[#8A867D]">
				<span>© {new Date().getFullYear()} competitorbacklinks.com</span>
				<span>
					Some links are affiliate links. We only recommend what we&rsquo;d use.
				</span>
			</div>
		</footer>
	)
}
